import React, { useState, useRef } from "react";
import * as Common from ".";

const FileUploader = ({
  label,
  helperText,
  onUploadClick,
  accept,
  isUploading = false,
  disabled = false,
  singleButton = false,
  btnText = "Upload file",
  singleBtnClassName = "",
}) => {
  const [selectedFile, setSelectedFile] = useState(null);
  const fileInputRef = useRef(null);

  // Default style for single-button mode
  const _singleBtnClassName =
    singleBtnClassName ||
    "text-sm font-medium text-gray-700 border border-gray-300 bg-white px-4 py-2 rounded-md shadow-sm hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-primary transition";

  const handleFileChange = (event) => {
    const file = event.target.files?.[0];
    if (!file) return;

    setSelectedFile(file);
    if (singleButton) onUploadClick(file);

    // Reset input so the same file can be selected again if needed
    event.target.value = null;
  };

  const handleUpload = () => {
    if (selectedFile) onUploadClick(selectedFile);
  };

  const SingleButton = () => (
    <button
      type="button"
      onClick={() => fileInputRef.current.click()}
      disabled={isUploading || disabled}
      className={`${_singleBtnClassName} ${
        disabled && !isUploading
          ? "bg-gray-200 text-gray-400 cursor-not-allowed"
          : ""
      }`}
    >
      {isUploading ? <Common.Spinner size="4" /> : btnText}
    </button>
  );

  return (
    <div>
      {label && (
        <label
          htmlFor="hidden_file_input"
          className="block mb-2 text-sm font-medium text-gray-900"
        >
          {label}
        </label>
      )}

      <div className="flex items-center gap-4">
        {/* Hidden native input to avoid blue highlight */}
        <input
          id="hidden_file_input"
          ref={fileInputRef}
          type="file"
          onChange={handleFileChange}
          disabled={isUploading || disabled}
          accept={accept}
          className="hidden"
        />

        {!singleButton && (
          <>
            <button
              type="button"
              onClick={() => fileInputRef.current.click()}
              disabled={isUploading || disabled}
              className={`px-4 py-2 text-sm font-medium rounded-md
                bg-white border border-gray-300 text-gray-700 shadow-sm
                hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-primary
                disabled:bg-gray-200 disabled:text-gray-400 disabled:cursor-not-allowed
                transition`}
            >
              {selectedFile ? selectedFile.name : "Choose file"}
            </button>

            <button
              type="button"
              onClick={handleUpload}
              disabled={!selectedFile || isUploading || disabled}
              className={`px-4 py-2 text-sm font-medium rounded-md
                bg-primary text-white hover:bg-primary/90
                focus:outline-none focus:ring-2 focus:ring-primary
                disabled:bg-gray-300 disabled:cursor-not-allowed
                transition`}
            >
              {isUploading ? <Common.Spinner /> : btnText}
            </button>
          </>
        )}

        {singleButton && <SingleButton />}
      </div>

      {helperText && <p className="mt-1 text-xs text-gray-500">{helperText}</p>}
    </div>
  );
};

export default FileUploader;
